import React from "react";
import LobbyMenuItems from "./LobbyMenuItems";
import MGLMenuItems from "./MGLMenuItems";

const SidebarContent = (props) => <>{props.lobbyType ? <MGLMenuItems {...props} /> : <LobbyMenuItems {...props} />}</>;

export default SidebarContent;
